import { Params, useParams } from "react-router-dom";
import { isTaskPromoTagPhotos } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { PromoTagPhotosPage } from "./PromoTagPhotosPage";

interface PromoTagPhotosParams extends Params {
    pointId: string;
    taskId: string;
}

const PromoTagPhotos = () => {
    const { pointId = "", taskId = "" } = useParams<PromoTagPhotosParams>();

    const currentPoint = usePointSelector(pointId);
    const currentTask = useTaskSelector(pointId, taskId);

    if (!currentPoint || !currentTask || !isTaskPromoTagPhotos(currentTask)) {
        return <NotFound />;
    }

    return <PromoTagPhotosPage task={currentTask} point={currentPoint} />;
};

export default PromoTagPhotos;
